import type { App } from 'vue';
import { createLegacyBreakpointsAdapter } from '@/utils/legacyBreakpointsAdapter.ts';

/**
 * Vue 3 plugin that provides breakpoints globally
 * This allows components to access breakpoints without explicit setup
 */
export default {
    install(app: App) {
        const breakpoints = createLegacyBreakpointsAdapter();

        // Provide globally so any component can inject it
        app.provide('breakpoints', breakpoints);

        // Add to global properties for Options API compatibility
        app.config.globalProperties.$breakpoints = breakpoints;

        // Expose individual properties via getters (for backwards compatibility)
        Object.defineProperty(app.config.globalProperties, 'mdLayout', {
            get() {
                return breakpoints.mdLayout.value;
            },
        });

        Object.defineProperty(app.config.globalProperties, 'lgLayout', {
            get() {
                return breakpoints.lgLayout.value;
            },
        });

        Object.defineProperty(app.config.globalProperties, 'xsLayout', {
            get() {
                return breakpoints.xsLayout.value;
            },
        });

        Object.defineProperty(app.config.globalProperties, 'smLayout', {
            get() {
                return breakpoints.smLayout.value;
            },
        });

        Object.defineProperty(app.config.globalProperties, 'xlLayout', {
            get() {
                return breakpoints.xlLayout.value;
            },
        });

        Object.defineProperty(app.config.globalProperties, 'oneXlLayout', {
            get() {
                return breakpoints.oneXlLayout.value;
            },
        });

        Object.defineProperty(app.config.globalProperties, 'xxlLayout', {
            get() {
                return breakpoints.xxlLayout.value;
            },
        });

        Object.defineProperty(app.config.globalProperties, 'phoneLayout', {
            get() {
                return breakpoints.phoneLayout.value;
            },
        });

        Object.defineProperty(app.config.globalProperties, 'isLandscape', {
            get() {
                return breakpoints.isLandscape.value;
            },
        });

        Object.defineProperty(app.config.globalProperties, '$mq', {
            get() {
                return breakpoints.currentBreakpoint.value || 'xs';
            },
        });
    },
};
